import request from '@/utils/request'


// 查询经销商设置身体标准值列表
export function listJoe(query) {
  return request({
    url: '/joe/dealer-standard/list',
    method: 'get',
    params: query
  })
}

// 查询经销商设置身体标准值分页
export function pageJoe(query) {
  return request({
    url: '/joe/dealer-standard/page',
    method: 'get',
    params: query
  })
}

// 查询经销商设置身体标准值详细
export function getJoe(data) {
  return request({
    url: '/joe/dealer-standard/detail',
    method: 'get',
    params: data
  })
}

// 新增经销商设置身体标准值
export function addJoe(data) {
  return request({
    url: '/joe/dealer-standard/add',
    method: 'post',
    data: data
  })
}

// 修改经销商设置身体标准值
export function updateJoe(data) {
  return request({
    url: '/joe/dealer-standard/edit',
    method: 'post',
    data: data
  })
}

// 删除经销商设置身体标准值
export function delJoe(data) {
  return request({
    url: '/joe/dealer-standard/delete',
    method: 'post',
    data: data
  })
}
